import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useState, useEffect, useRef } from 'react'
import EditableAccordion from '../EditableAccordion'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { useTheme } from '@emotion/react'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'


function RenderComponente({ componente, updateSelection, padding, marginLevel = 0, statoPratica, ndRequired, disable }) {
  const {
    id,
    tipoComponente,
    label,
    value,
    placeHolder,
    isSelected,
    children = [],
    disposizioneFigli,
    obbligatorio,
    mostraFigli,
  } = componente
  const theme = useTheme()
  const [isOpen, setIsOpen] = useState(false)
  const [isChecked, setIsChecked] = useState(isSelected)
  const [expanded, setExpanded] = useState(false)
  const [selectedValue, setSelectedValue] = useState(null)
  const [inputValue, setInputValue] = useState(value || '')
  const didMount = useRef(false)
  console.log('DISABLE  ', disable)
  console.log('COMPONENTE ',componente.label)


  useEffect(() => {
    if (didMount.current) {
      updateSelection(componente, isChecked, inputValue)
    } else {
      didMount.current = true
    }

  }, [isChecked, inputValue])

  useEffect(() => {
    const selectedChild = children.find(child => child.isSelected === true)
    if (selectedChild) {
      setSelectedValue(selectedChild.id)
    }
  }, [children])

  if (!componente) {
    return null
  }

  const handleUpdateAttivitaSvolte = (attivita) => {
    console.log('ATTIVITA ', attivita)
    componente.attivitaSvolteList = attivita
    updateSelection(componente, true)
  }

  const handleTextFieldChange = (event) => {
    const newValue = event.target.value
    setInputValue(newValue)
    if (newValue === null || newValue === '') {
      setIsChecked(false)
    } else {
      setIsChecked(true)
    }
  }

  const handleRadioChange = (event) => {
    const newValue = event.target.value
    setSelectedValue(newValue)
    children.forEach((child) => {
      if (child.id.toString() === newValue) {
        updateSelection(child, true)
      } else {
        updateSelection(child, false)
      }
    })
  }

  const onChangeCheckBoxDUE = (e, child) => {
    const isCheckedNow = !child.isSelected
    updateSelection(child, isCheckedNow)
  }

  const findSelectedChild = (nodes) => {
    for (const node of nodes) {
      if (node.isSelected) {
        return node.id
      }
    }
    return ''
  }

  const renderContent = () => {
    switch (tipoComponente) {
        case 'TEXT':
        case'TEXT_HEADER':
        return <Typography
          variant={'caption'}
        >
          {label}
          {(children && children.length > 0) && children.map((child, index) => (
            <RenderComponente key={index} componente={child}
                              marginLevel={marginLevel + 1}
                              ndRequired={true}
                              {...{disable,statoPratica,updateSelection}}
            />
          ))}
        </Typography>

      case 'TEXTFIELD':
        return (
          <div>
            <div><Typography
              variant={'caption'}
              sx={{
                whiteSpace: 'pre-wrap',
                overflowWrap: 'break-word',
                display: 'block',
                marginBottom: '4px',
              }}>{label}</Typography>
            </div>
            <div><TextField
              placeholder={placeHolder}
              value={inputValue}
              disabled={label==='Esito ADVR' ? true : disable}
              onChange={handleTextFieldChange}
              required={obbligatorio}
              fullWidth
              variant="outlined"
              margin="normal"
              multiline
              minRows={1}
              maxRows={Infinity}
              InputProps={{

                sx: {
                  backgroundColor: 'white',
                  padding: '2px',
                  color: 'black',
                  '& input::placeholder, & textarea::placeholder': {
                    color: 'black !important',
                    opacity: 1,
                  },
                },
              }}
              sx={{
                marginTop: '0 !important',
                textarea: {
                  backgroundColor: 'white !important',
                  padding: '2px !important',
                  color: 'black !important',
                },
              }}
            /></div>
          </div>
        )
      case 'RADIO_GROUP':
        const initialSelectedValue = findSelectedChild(children)

        return (
          <RadioGroup
              value={selectedValue || initialSelectedValue}
              onChange={handleRadioChange}
              row={disposizioneFigli === 'ORIZ'}
              sx={{width: '100%'}}
            >
              {children?.map((child) =>
                [
                  <FormControlLabel
                    key={child.id}
                    value={child.id}
                    disabled={disable}
                    control={
                      <Radio
                        disabled={disable}
                        onClick={(e) => {
                          if (selectedValue === child.id.toString()) {
                            setSelectedValue(null)
                            updateSelection(child, false)
                            e.stopPropagation()
                          }
                        }

                        }
                        sx={{
                          minWidth: '15px',
                          alignSelf: 'flex-start',
                          marginTop: '2px',

                          '&.MuiRadio-root': {
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            padding: 0,

                          },
                          '&.Mui-checked': {
                            padding: '3px',
                            backgroundColor: 'transparent',
                          },
                        }}

                      />}
                    label={<Typography variant="caption">{child.label}</Typography>}

                  />,
                  (selectedValue === child.id.toString() || child.isSelected) && child.children?.map((grandChild) => (
                    <RenderComponente
                      key={grandChild.id}
                      componente={grandChild}
                      updateSelection={updateSelection}
                      marginLevel={marginLevel + 1}
                      statoPratica={statoPratica}
                      
                      disable={disable}
                    />
                  )),
                ],
              )}

            </RadioGroup>
        )

      case 'ATTIVITA':
        return <EditableAccordion
              attivitaSvolteList={componente?.attivitaSvolteList || []}
              onUpdateAttivita={handleUpdateAttivitaSvolte}
              canAddAttivita={!disable}
            />
      case 'ACCORDION':
        const leftMargin = marginLevel*5;
        return (
          <Accordion
            disableGutters
            elevation={0}
            expanded={expanded}
            onChange={() => setExpanded(prevState => !prevState)}
            sx={{
              backgroundColor: theme.palette.yellow.middle,
              width: '100%',
              borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
            }}
          >
            <AccordionSummary expandIcon={<ArrowDropDownIcon />}>
              {label}
            </AccordionSummary>
            <AccordionDetails>
              {(expanded && children && children.length > 0) ? children.map((child, index) => (
                <RenderComponente key={index} componente={child} updateSelection={updateSelection}
                                  marginLevel={marginLevel + 1}
                                  statoPratica={statoPratica}
                                  disable={disable}
                />
              ))
              :<Typography
                  variant={'caption'}
                  sx={{
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'break-word',
                    display: 'block',
                    marginBottom: '4px',
                    marginLeft: leftMargin
                  }}>N.D.</Typography>
              }
            </AccordionDetails>
          </Accordion>
        )

      case 'MULTI_CHECK':
        return (
          <FormGroup
              row={disposizioneFigli === 'ORIZ'}
              disabled={disable}
            >
              {children?.map((child) =>
                [
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={disable}
                        checked={child.isSelected}
                        onChange={(e) => onChangeCheckBoxDUE(e, child)}
                        sx={{
                          minWidth: '15px',
                          maxHeight: '15px',
                          background: 'white',
                          alignSelf: 'flex-start',
                          marginTop: '4px',
                        }}
                      />
                    }
                    label={<Typography variant="caption">{child.label}</Typography>}

                  />,
                  child.isSelected && child.children && child.children?.map((grandChild) => (
                    <RenderComponente
                      key={grandChild.id}
                      componente={grandChild}
                      updateSelection={updateSelection}
                      marginLevel={marginLevel + 1}
                      statoPratica={statoPratica}
                      disable={disable}
                    />
                  )),
                ],
              )}
            </FormGroup>
        )

      default:
        return <Typography>Componente non supportato</Typography>
    }
  }

  const getChildStyle = () => {
    const margin = marginLevel * 5
    if (disposizioneFigli === 'ORIZ') {
      return { display: 'flex', flexDirection: 'row', width:'100%',marginBottom: '10px', marginLeft: margin }
    } else if (disposizioneFigli === 'VERT') {
      return { display: 'flex', flexDirection: 'column',width:'100%', marginBottom: '10px', marginLeft: margin }
    } else if (disposizioneFigli === 'IN_LINEA') {
      return { display: 'flex', flexDirection: 'row', /*gap: '1rem',*/ marginLeft: margin }
    } else {
      return { display: 'flex', flexDirection: 'column', /*gap: '1rem',*/ marginLeft: margin }
    }
  }

  return (
    <div
      style={
        getChildStyle()
      }
    >
      {renderContent()}

      {/*Mostra i figli se la sezione è aperta
      {
        (
          (tipoComponente !== 'ACCORDION' && tipoComponente !== 'RADIO_GROUP' &&
            ((statoPratica && (statoPratica === 'DA APPROVARE' || statoPratica === 'CHIUSA'))
              || ((mostraFigli === 'ALWAYS' || (mostraFigli === 'IF_SELECTED' && isChecked)) && children.length > 0))
          )
        ) && children.map((child, index) => (
          <RenderComponente key={index} componente={child} updateSelection={updateSelection} marginLevel={marginLevel + 1}
                            statoPratica={statoPratica} customStyle={getChildStyle()} />
        ))}*/}
    </div>
  )
}


export default RenderComponente